"use strict";

var _interopRequireDefault = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _CustomOfficialEvents = _interopRequireDefault(require("./CustomOfficialEvents.vue"));
var _goodsListPage = _interopRequireDefault(require("./goodsListPage.vue"));
var _otherPlatform = _interopRequireDefault(require("./otherPlatform.vue"));
var _CustomOfficialEvents2 = _interopRequireDefault(require("./CustomOfficialEvents1.vue"));
var _PolymerizationActivityPopup = _interopRequireDefault(require("./PolymerizationActivityPopup.vue"));
var _GeneralH5Activity = _interopRequireDefault(require("./GeneralH5Activity.vue"));
var _CustomizePage = _interopRequireDefault(require("./CustomizePage.vue"));
var _newCustomizePage = _interopRequireDefault(require("./newCustomizePage.vue"));
var _TaobaoSubsidy = _interopRequireDefault(require("./TaobaoSubsidy.vue"));
var _supersubsidy = _interopRequireDefault(require("./supersubsidy.vue"));
var _wedding = _interopRequireDefault(require("./wedding.vue"));
var _store = _interopRequireDefault(require("@/store"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'ActivitySelectionPopup',
  components: {
    wedding: _wedding.default,
    newCustomizePage: _newCustomizePage.default,
    CustomOfficialEvents: _CustomOfficialEvents.default,
    CustomOfficialEvents1: _CustomOfficialEvents2.default,
    PolymerizationActivityPopup: _PolymerizationActivityPopup.default,
    GeneralH5Activity: _GeneralH5Activity.default,
    CustomizePage: _CustomizePage.default,
    GoodsListPage: _goodsListPage.default,
    otherPlatform: _otherPlatform.default,
    TaobaoSubsidy: _TaobaoSubsidy.default,
    supersubsidy: _supersubsidy.default
  },
  data: function data() {
    return {
      showPopup: false,
      categoryData: [{
        name: '自定义活动',
        id: 1
      }, {
        name: '商品列表活动',
        id: 6
      }, {
        name: '官方活动',
        id: 2
      }, {
        name: '聚合页活动',
        id: 3
      }, {
        name: '通用H5活动',
        id: 4
      }, {
        name: '第三方代下单',
        id: 7
      }, {
        name: '自定义页面',
        id: 10
      }, {
        name: '自定义页面(旧版)',
        id: 5
      }, {
        name: '礼金补贴活动(旧版)',
        id: 8
      }, {
        name: '超级补贴活动',
        id: 9
      }, {
        name: '礼金补贴活动',
        id: 11
      }],
      selectCategory: 1
    };
  },
  methods: {
    open: function open() {
      if (_store.default.getters.appId * 1 === 0) {
        // 超管端判断，只显示超管端维护的活动
        this.categoryData = this.categoryData.filter(function (i) {
          return i.id === 2 || i.id === 4 || i.id === 7;
        });
        this.selectCategory = 2;
      }
      this.showPopup = true;
    },
    onClone: function onClone() {
      this.showPopup = false;
    },
    onCategory: function onCategory(value) {
      this.selectCategory = value.id;
    },
    // 自定义活动回传
    onSelectEvents: function onSelectEvents(data) {
      console.log(data, '===========================');
      this.$emit('SelectEvents', data);
      this.onClone();
    },
    // 防止穿透
    handleSmallDivClick: function handleSmallDivClick() {}
  }
};